/**
 * Captured origin of the parent window, set once we receive the first
 * legitimate message from it. Used as the targetOrigin for all outgoing
 * postMessage calls so we never broadcast to unknown origins.
 */
let _parentOrigin: string | null = null;

export function setParentOrigin(origin: string): void {
  _parentOrigin = origin;
}

/** Returns the captured parent origin, or '*' before the first message arrives. */
export function getParentOrigin(): string {
  return _parentOrigin ?? '*';
}
